import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import IconButton from "@material-ui/core/IconButton";
import Slide from "@material-ui/core/Slide";
import { withStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import ApolloClient from "apollo-client";
import { Field, Formik, FormikActions, FormikProps } from "formik";
import React, { useState } from "react";
import { ApolloConsumer } from "react-apollo";
import voca from "voca";
import * as Yup from "yup";
import MaterialDropZone from "../../../componentes/DropZone";
import Loading from "../../../componentes/Loading/Loading";
import FormikInputText from "../../../componentes/MaskedInput/FomikInput";
import SnackMessage from "../../../componentes/SnakBar";
import TabelaRolavel from "../../../componentes/Tables/TabelaRolavel";
import {
  AprovarUrlProps, BaixarArquivoEstabelecimentoDocument,
  BaixarArquivoEstabelecimentoQuery, CanUploadComponent,




  CanUploadDocument,




  CanUploadQuery,




  CanUploadQueryVariables,




  DocumentosBean, GetPainelCadastroDocument, withAprovarUrl
} from "../../../graphql/components";

const styles = (theme: any) => ({
  table: {
    fontFamily: theme.typography.fontFamily,
    "&:hover": {
      backgroundColor: theme.palette.grey[200],
      cursor: "pointer",
    },
  },
});
const Transition = React.forwardRef<unknown, React.ComponentProps<typeof Slide>>(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...(props as React.ComponentProps<typeof Slide>)} />;
});

const Schema = Yup.object().shape({
  identificador: Yup.string(),
  usuario: Yup.string().required(`Usuário é obrigatório.`),
  senha: Yup.string().required(`Senha é obrigatório.`),
});

const initialValues = {
  identificador: "",
  usuario: "",
  senha: "",
};

type FormValues = typeof initialValues;

interface Props {
  open: boolean;
  handleCloseUpload: () => void;
  files?: Array<File>;
  realizeUpload: () => void;
  setUpload: (files: Array<File>) => void;
  uploading: boolean;
  tipoDoc: string;
  codoperadora: number;
  classes?: any;
}

const baixarArquivo = async (
  client: ApolloClient<any>,
  coddocumentos: number,
  setDownloading: React.Dispatch<React.SetStateAction<boolean>>
) => {
  setDownloading(true);
  const { data, loading } = await client.query<BaixarArquivoEstabelecimentoQuery>({
    query: BaixarArquivoEstabelecimentoDocument,
    variables: { values: { coddocumentos } },
  });
  setDownloading(loading);
  if (data) {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_HOST}/temp/${data.baixarArquivoEstabelecimento}`;
    link.download = `${process.env.REACT_APP_HOST}/temp/${data.baixarArquivoEstabelecimento}`.split("/").pop()!;
    if (data.baixarArquivoEstabelecimento!.toLowerCase().indexOf("pdf") > -1) {
      link.target = "_blank";
    }
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    link.remove();
  }
};

const UploadPainelCadastro = ({
  open,
  handleCloseUpload,
  files,
  realizeUpload,
  setUpload,
  uploading,
  classes,
  tipoDoc,
  codoperadora,
  mutate,
}: AprovarUrlProps<Props>) => {
  const [downloading, setDownloading] = useState(false);

  const [exibirUrl, setExibirUrl] = useState<boolean | undefined>();
  const [canUpload, setCanUpload] = useState<boolean | undefined>();
  const [msg, setMsg] = useState<string>("");
  const [documentos, setDocumentos] = useState<Array<DocumentosBean>>([]);

  const [usuarioDisabled, setUsuarioDisabled] = useState<boolean>(false);

  const verifyCpfEmail = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>, formikBag: FormikProps<FormValues>) => {
    const value = event.target.value;
    //eslint-disable-next-line
    const regexEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
   
    //eslint-disable-next-line
    if(value.match(/^\d{3}\.\d{3}\.\d{3}\-\d{2}$/) || (voca.isNumeric(value) && value.length === 11) || value.match(regexEmail)) {
      formikBag.setFieldValue("usuario", value);
      formikBag.setFieldValue("identificador", "");
      // setUsuarioDisabled(true);
    } else {
      formikBag.setFieldValue("usuario", "");
      // setUsuarioDisabled(false);
    }
  };

  const validate = React.useCallback(
    async (values: FormValues, actions: FormikActions<FormValues>) => {
      const response = await mutate({
        variables: {
          values: { identificacao: values.identificador, password: values.senha, usuario: values.usuario, codoperadora },
        },
        refetchQueries: [{
          query: GetPainelCadastroDocument
        }],
        awaitRefetchQueries: true,
        update: (store, result) => {
            store.writeQuery<CanUploadQuery, CanUploadQueryVariables>({
              query: CanUploadDocument,
              variables: {tipoDoc, values: { codoperadora }},
              data: {
                canUpload: {
                  documentos: result.data?.aprovarUrl.documentos ?? [],
                  canUpload: result.data?.aprovarUrl.canUpload,
                  exibirUrl: result.data?.aprovarUrl.exibirUrl,
                  __typename: "CanUploadResult"
                }
              }
            });
        }
      });

      setExibirUrl(response.data?.aprovarUrl.exibirUrl);
      setCanUpload(response.data?.aprovarUrl.canUpload);
      setDocumentos(response.data?.aprovarUrl.documentos ?? []);
      setMsg(response.data?.aprovarUrl.msg ?? "");
      actions.setSubmitting(false);
    },
    [mutate, codoperadora]
  );

  return (
    <Dialog fullScreen open={open} onClose={handleCloseUpload} TransitionComponent={Transition as any}>
      <AppBar style={{ position: "relative" }}>
        <Toolbar>
          <IconButton color="inherit" onClick={handleCloseUpload} aria-label="Fechar">
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" color="inherit" style={{ flex: 1 }}>
            Upload de arquivos
          </Typography>
          {files && (
            <Button color="inherit" style={{ fontSize: 18 }} onClick={realizeUpload} disabled={uploading}>
              Confirmar upload
            </Button>
          )}
        </Toolbar>
      </AppBar>
      <div>
        <CanUploadComponent variables={{ tipoDoc, values: { codoperadora } }}>
          {({ data, loading }) => {
            if (loading || downloading) return <Loading />;
            if (data) {
              const docs =
                data.canUpload.documentos && data.canUpload.documentos.length > 0 ? data.canUpload.documentos : documentos;
              return (
                <React.Fragment>
                  {(!data.canUpload.exibirUrl || exibirUrl === false) &&
                    (data.canUpload.canUpload || canUpload) &&
                    !uploading && (
                      <MaterialDropZone
                        acceptedFiles={[
                          "pdf",
                          "doc",
                          "docx",
                          "application/pdf",
                          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                          "application/msword",
                          "image/jpeg",
                          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        ]}
                        files={[]}
                        showPreviews
                        maxSize={15000000}
                        filesLimit={1}
                        text="Arraste seus arquivos para esta tela ou clique aqui para selecioná-los."
                        uploadMethod={setUpload}
                      />
                    )}
                  {(data.canUpload.exibirUrl || canUpload) && (
                    <Formik
                      initialValues={initialValues}
                      onSubmit={validate}
                      validationSchema={Schema}
                      render={(formikBag: FormikProps<FormValues>) => (
                        <form autoComplete="new-password" role="presentation" onSubmit={formikBag.handleSubmit}>
                          <Grid container spacing={2} style={{ padding: 25 }}>
                            <Grid item xs={12} md={4}>
                            {!formikBag.values.usuario &&  <Field
                                id="identificador"
                                name="identificador"
                                component={FormikInputText}
                                label="Estabelecimento / Cpf / E-mail"
                                disabled={formikBag.isSubmitting}
                                onBlur={(event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => verifyCpfEmail(event, formikBag)}
                              />}
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Field id="usuario" name="usuario" component={FormikInputText} label="Usuário" disabled={usuarioDisabled || formikBag.isSubmitting}/>
                            </Grid>
                            <Grid item xs={12} md={4}>
                              <Field id="senha" name="senha" component={FormikInputText} label="Senha" password disabled={formikBag.isSubmitting}/>
                            </Grid>
                            <Grid item xs={12}>
                              <Button type="submit" color="primary" disabled={formikBag.isSubmitting}>
                                Validar
                              </Button>
                            </Grid>
                          </Grid>
                        </form>
                      )}
                    />
                  )}
                  <TabelaRolavel>
                    <TableHead>
                      <TableRow>
                        <TableCell>Nome</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Observação</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <ApolloConsumer>
                        {(client) => (
                          <React.Fragment>
                            {docs.map((doc: any, index: number) => (
                              <TableRow
                                key={`${doc.nome}${doc.status}${index}`}
                                className={classes.table}
                                onClick={() => baixarArquivo(client as any, doc.coddocumentos, setDownloading)}
                              >
                                <TableCell>{doc.nome}</TableCell>
                                <TableCell>{doc.status}</TableCell>
                                <TableCell>{doc.obs}</TableCell>
                              </TableRow>
                            ))}
                          </React.Fragment>
                        )}
                      </ApolloConsumer>
                    </TableBody>
                  </TabelaRolavel>
                  <SnackMessage message={msg} variant="warning" open={msg.length > 0} close={() => setMsg("")} />
                </React.Fragment>
              );
            }
            return null;
          }}
        </CanUploadComponent>
        {uploading && <Loading />}
      </div>
    </Dialog>
  );
};

const withMutate = withAprovarUrl<Props>({});

export default withStyles(styles as any)(withMutate(UploadPainelCadastro));
